export enum TipoCatalogo {
  Actualizable = 1,
  Consulta = 2
}
